import { request } from '@/shared/api/request'

export const getPersonsList = (params, id) => {
	return request({ url: `colcontract/tradeUnion/person/page/${id}`, method: 'POST', params })
}
